import ModelStore from 'stores/model/ModelStore'

import createError from 'utils/createError'

const getCountQuery = ({ modelId }: { modelId: string }) => {
  const model = ModelStore.get(modelId)
  if (!model) {
    throw createError('getCountQuery', 'Invalid modelId', {
      modelId,
    })
  }

  return `prisma.${model.photonNamespace}.count()`
}

export default getCountQuery
